var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('img', {
    staticClass: "flag ml-2",
    class: {
      'language-opacity': _vm.$i18n.locale !== 'hu'
    },
    attrs: {
      "src": require("@/assets/language/hungary.png"),
      "alt": "Hungarian Flag"
    },
    on: {
      "click": function ($event) {
        return _vm.change('hu');
      }
    }
  }), _c('img', {
    staticClass: "flag ml-2",
    class: {
      'language-opacity': _vm.$i18n.locale !== 'en'
    },
    attrs: {
      "src": require("@/assets/language/united-kingdom.png"),
      "alt": "United Kingdom flag"
    },
    on: {
      "click": function ($event) {
        return _vm.change('en');
      }
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }